import { RootDispatch } from "@store";
import {
  EQUIPMENT_TYPES,
  ActionCreateEquipment,
  ActionDeleteEquipment,
  ActionEditEquipment,
  ActionSetEquipment,
  IWorkEquipment,
  IAvailableEquipment,
} from "./actionTypes";

export const setAvailableEquipment = (
  payload: IWorkEquipment[]
): ActionSetEquipment => {
  return {
    type: EQUIPMENT_TYPES.SET_AVAILABLE_EQUIPMENT,
    payload,
  };
};

export const createAvailableEquipment = (
  payload: IAvailableEquipment
): ActionCreateEquipment => {
  return {
    type: EQUIPMENT_TYPES.CREATE_AVAILABLE_EQUIPMENT,
    payload,
  };
};
export const editAvailableEquipment = (
  payload: IAvailableEquipment
): ActionEditEquipment => {
  return {
    type: EQUIPMENT_TYPES.EDIT_AVAILABLE_EQUIPMENT,
    payload,
  };
};
export const deleteAvailableEquipment = (
  payload: string
): ActionDeleteEquipment => {
  return {
    type: EQUIPMENT_TYPES.DELETE_AVAILABLE_EQUIPMENT,
    payload,
  };
};

//

export const setWorkEquipment = (
  payload: IWorkEquipment[]
): ActionSetEquipment => {
  return {
    type: EQUIPMENT_TYPES.SET_WORK_EQUIPMENT,
    payload,
  };
};

export const addWorkEquipment = (
  payload: IWorkEquipment
): ActionCreateEquipment => {
  return {
    type: EQUIPMENT_TYPES.ADD_WORK_EQUIPMENT,
    payload,
  };
};
export const editWorkEquipment = (
  payload: IWorkEquipment
): ActionEditEquipment => {
  return {
    type: EQUIPMENT_TYPES.EDIT_WORK_EQUIPMENT,
    payload,
  };
};
export const deleteWorkEquipment = (payload: string): ActionDeleteEquipment => {
  return {
    type: EQUIPMENT_TYPES.DELETE_WORK_EQUIPMENT,
    payload,
  };
};
